<script>
import { defineComponent } from 'vue';
import { AisPanel, AisRefinementList } from 'vue-instantsearch/vue3/es';

export default defineComponent({
  components: {
    AisPanel,
    AisRefinementList,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    attribute: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isActive = !this.isActive;
    },
  },
});
</script>
<template>
  <ais-panel
    :class-names="{
      'ais-Panel--noRefinement': 'c-product-filter__filter-hidden',
      'ais-Panel-body': `${isActive ? 'c-product-filter__active' : 'c-product-filter__filter-hidden'}`,
    }"
  >
    <template #header="{ hasRefinements }">
      <button
        v-show="hasRefinements"
        class="c-product-filter__filter-button"
        @click="toggleDropdown"
      >
        {{ label }}
        <svg
          ref="chevron"
          :class="`${isActive ? 'c-product-filter__filter-chevron c-product-filter__filter-chevron--open' : 'c-product-filter__filter-chevron'}`"
          xmlns="http://www.w3.org/2000/svg"
          width="8.121"
          height="13.414"
          viewBox="0 0 8.121 13.414"
        >
          <path
            d="M7016.708,2821.379l-1.414-1.414,5.293-5.293-5.293-5.293,1.414-1.414,6.707,6.707Z"
            transform="translate(-7015.294 -2807.965)"
            fill="#003D31"
          />
        </svg>
      </button>
    </template>

    <ais-refinement-list
      ref="refinementList"
      :attribute="attribute"
      :limit="100"
      :sort-by="['name:asc']"
    >
      <template #default="{ items, refine }">
        <ul class="c-product-filter__refinement-list">
          <li
            v-for="item in items"
            :key="item.value"
            class="c-product-filter__refinement-list-item"
          >
            <input
              type="checkbox"
              class="c-product-filter__refinement-list-checkbox"
              :checked="!!item.isRefined"
              @click="refine(item.value)"
            >
            <a
              class="c-product-filter__refinement-list-link"
              @click.prevent="refine(item.value)"
            >
              {{ item.label }}
            </a>
          </li>
        </ul>
      </template>
    </ais-refinement-list>
  </ais-panel>
</template>
